import View from '@/components/common/view'
import FillinRecognizee from '../components/appProduct/FillinRecognizee';
import FillinSuccess from '../components/appProduct/FillinSuccess';

export default[
    {
        path: '',
        component: View,
        children: [
            {
                path: 'fillin-recognizee/:policyId/:id',
                component: FillinRecognizee,
                meta:{
					hideLogin:true
				}
            },
            {
                path: 'fillin-success',
                component: FillinSuccess,
                meta: {
                    hideLogin: true
                }
            }
        ]
    }
]


// WEBPACK FOOTER //
// ./src/pages/haierProduct/router/appProduct.js